import api from './api';

export interface SiteEmpresaDto {
    idEmpresa: string;
    slug: string;
    categoria: number;
    publicado: boolean;
    corPrimaria: string;
    corSecundaria: string;
    logoArquivoId: string | null;
    whatsappComercial: string;
    instagram: string;
    facebook: string;
    enderecoExibido: string;
    exibeAreaCliente: boolean;
    exibeVeiculosIndisponiveis: boolean;
    secoesJson: string;
}

export interface SiteVeiculoDto {
    idVeiculo: string;
    marca: string;
    modelo: string;
    ano: string;
    cor: string;
    visivel: boolean;
    ordem: number;
    precoDiaria: number | null;
    precoSemanal: number | null;
    precoMensal: number | null;
    precoSugeridoAplicado: boolean;
    precoAproximadoQuinzenal: boolean;
    fotoOverrideArquivoId: string | null;
    fotoArquivoId: string | null;
}

export type HeroEstilo = 'claro' | 'escuro' | 'primaria' | 'gradiente';

export interface SecoesHero {
    visivel: boolean;
    titulo: string;
    subtitulo: string;
    imagemArquivoId: string | null;
    estilo?: HeroEstilo;
    corFundo?: string | null;
    badgeVisivel?: boolean;
    badgeTitulo?: string;
    badgeTexto?: string;
}

export interface SecoesFrota {
    visivel: boolean;
    titulo: string;
}

export interface SecoesComoFuncionaItem {
    titulo: string;
    texto: string;
}

export interface SecoesComoFunciona {
    visivel: boolean;
    titulo: string;
    itens: SecoesComoFuncionaItem[];
}

export interface SecoesDepoimentoItem {
    nome: string;
    texto: string;
    nota: number;
}

export interface SecoesDepoimentos {
    visivel: boolean;
    itens: SecoesDepoimentoItem[];
}

export interface SecoesFaqItem {
    pergunta: string;
    resposta: string;
}

export interface SecoesFaq {
    visivel: boolean;
    itens: SecoesFaqItem[];
}

export interface SecoesSobre {
    visivel: boolean;
    texto: string;
}

export interface SecoesLocalizacao {
    visivel: boolean;
    endereco: string;
    mapsUrl: string;
    telefone: string;
    email: string;
}

export interface SecoesWhatsappFlutuante {
    visivel: boolean;
    mensagemPadrao: string;
}

export interface SecoesSeo {
    titulo: string;
    descricao: string;
}

export interface Secoes {
    seo?: SecoesSeo;
    hero: SecoesHero;
    frota: SecoesFrota;
    comoFunciona: SecoesComoFunciona;
    depoimentos: SecoesDepoimentos;
    faq: SecoesFaq;
    sobre: SecoesSobre;
    localizacao: SecoesLocalizacao;
    whatsappFlutuante: SecoesWhatsappFlutuante;
}

export const obterMeuSite = () =>
    api.get<SiteEmpresaDto | null>('/MeuSite');

export const atualizarMeuSite = (dto: SiteEmpresaDto) =>
    api.put('/MeuSite', dto);

export const sincronizarVeiculos = () =>
    api.post<SiteVeiculoDto[]>('/MeuSite/sincronizar-veiculos');

export const listarVeiculos = () =>
    api.get<SiteVeiculoDto[]>('/MeuSite/veiculos');

export const atualizarVeiculos = (itens: SiteVeiculoDto[]) =>
    api.put('/MeuSite/veiculos', itens);

export const atualizarPublicacao = (publicado: boolean) =>
    api.put('/MeuSite/publicacao', { publicado });

export const obterUrlImagemPreview = async (arquivoId: string): Promise<string | null> => {
    try {
        const res = await api.get<{ url: string }>(`/MeuSite/imagem/${arquivoId}`);
        return res.data?.url || null;
    } catch {
        return null;
    }
};

export const uploadLogo = (arquivo: File) => {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return api.post<{ arquivoId: string }>('/MeuSite/logo', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const uploadImagemHero = (arquivo: File) => {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return api.post<{ arquivoId: string }>('/MeuSite/imagem-hero', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const uploadFotoVeiculo = (idVeiculo: string, arquivo: File) => {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return api.post<{ arquivoId: string }>(`/MeuSite/veiculos/${idVeiculo}/foto`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
